import { render } from "./Tm_header.vue?vue&type=template&id=702cf7d4&scoped=true&ts=true"
import script from "./Tm_header.vue?vue&type=script&lang=ts"
export * from "./Tm_header.vue?vue&type=script&lang=ts"

import "./Tm_header.vue?vue&type=style&index=0&id=702cf7d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702cf7d4"]])

export default __exports__